module.exports = __webpack_public_path__ + "static/img/supplier5.f8788a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplier5.png
// module id = LnVj
// module chunks = 192